import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import { pageLink } from '../utils/urls';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const FinalProvisions = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      10. Postanowienia końcowe.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>10.1.</ListItemIcon>
        <ListItemText>
          1 Regulamin, wraz z wprowadzonymi zmianami, obowiązuje od dnia 13
          lutego 2025 r.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>10.2.</ListItemIcon>
        <ListItemText>
          Regulamin dostępny jest na stałe na stronie internetowej Serwisu{' '}
          {pageLink}.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>10.3.</ListItemIcon>
        <ListItemText>
          Administrator ma możliwość wprowadzenia zmian w Regulaminie, z ważnych
          przyczyn, którymi są:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                zmiana lub wprowadzenie nowych przepisów powszechnie
                obowiązującego prawa, dotyczących zagadnień uregulowanych w
                Regulaminie, jeżeli te zmiany lub wprowadzenie nowych przepisów,
                zobowiązuje Administratora do zmiany Regulaminu. W takim
                przypadku, zmiana Regulaminu będzie obejmowała te jego
                postanowienia, które pozostają w bezpośrednim związku z
                przyczyną uzasadniającą tą zmianę i nastąpi w kierunku zgodnym z
                treścią zmienionych lub nowych przepisów powszechnie
                obowiązującego prawa,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                ) rekomendacja, interpretacja lub orzeczenie wydane przez
                Prezesa Urzędu Ochrony Konkurencji i Konsumentów, Komisji
                Nadzoru Finansowego, Generalnego Inspektora Informacji
                Finansowej, Prezesa Urzędu Ochrony Danych Osobowych, organu
                podatkowego w rozumieniu art. 13 i 13a ustawy z dnia 29.08.1997
                r. Ordynacja podatkowa (t.j. Dz.U. z 2021 r., poz. 1540, z późn.
                zm.), sąd powszechny, Sąd Najwyższy lub sąd administracyjny,
                jeżeli wiąże Administratora i gdy z niego wynika, że
                Administrator jest zobowiązany do dostosowania treści Regulaminu
                do tej rekomendacji, interpretacji lub orzeczenia. W takim
                przypadku, zmiana Regulaminu będzie obejmowała te jego
                postanowienia, które pozostają w bezpośrednim związku z
                przyczyną uzasadniającą tą zmianę i nastąpi w kierunku zgodnym z
                treścią tej rekomendacji, interpretacji lub orzeczenia,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                zmiana funkcjonalności udostępnianych przez Administratora w
                ramach Serwisu, zmiana formy, nazwy lub adresu Administratora
                lub zmiana tożsamości, nazwy lub adresu podmiotu określonego w
                pkt 8.2 Regulaminu, jeżeli zakres tej zmiany, wymaga także
                dostosowania treści Regulaminu. W takim przypadku zmiana
                Regulaminu będzie obejmowała te jego postanowienia, które
                pozostają w bezpośrednim związku z przyczyną uzasadniającą tą
                zmianę i nastąpi w kierunku zgodnym z przyczyną zmiany.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>10.4.</ListItemIcon>
        <ListItemText>
          W przypadkach określonych w pkt. 10.3 Regulaminu, Administrator
          poinformuje Użytkownika o zmianie Regulaminu co najmniej na 14 dni
          przed wejściem w życie zmienionego Regulaminu, za pośrednictwem
          wiadomości wysłanej do Użytkownika na wskazany przez niego adres
          poczty elektronicznej (e–mail), wraz z nowym brzmieniem Regulaminu.
          Jeżeli przed proponowanym dniem wejścia w życie zmian Regulaminu
          Użytkownik nie zgłosi Administratorowi sprzeciwu wobec proponowanych
          zmian, uznaje się, że Użytkownik wyraził na nie zgodę.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>10.5.</ListItemIcon>
        <ListItemText>
          Jeżeli Użytkownik nie zgadza się na proponowaną zmianę Regulaminu,
          może, przed dniem wejścia w życie zmiany:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                zrezygnować z korzystania z Usług, składając, rezygnację w
                trybie określonym w pkt 3.18 Regulaminu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                złożyć sprzeciw wobec proponowanych zmian Regulaminu, o czym
                Użytkownik powinien poinformować Administratora, w wybranej
                przez siebie formie komunikacji określonej w pkt. 9.2
                Regulaminu. W przypadku zgłoszenia sprzeciwu, o ile Użytkownik
                nie zrezygnował z korzystania z Usług, Konto ulegnie
                dezaktywacji z upływem dnia poprzedzającego dzień wejścia w
                życie proponowanych zmian Regulaminu.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>10.6.</ListItemIcon>
        <ListItemText>
          Zmiany Regulaminu nie mają wpływu na aktywności Użytkownika dokonane
          przed wejściem w życie takich zmian.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default FinalProvisions;
